/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const KeyIsNotNullLabelKey: core.serialization.ObjectSchema<
    serializers.KeyIsNotNullLabelKey.Raw,
    Truvity.KeyIsNotNullLabelKey
> = core.serialization.object({
    key: core.serialization.string(),
});

export declare namespace KeyIsNotNullLabelKey {
    export interface Raw {
        key: string;
    }
}
